(() => {
  // This key records only whether the notice UI was dismissed, never consent.
  const key = 'gkmhem-db-cookie-ui-dismissed';
  const notice = document.querySelector('[data-cookie-ui]');
  if (!notice || notice.dataset.initialized) return;
  notice.dataset.initialized = 'true';
  let dismissed = false;
  try { dismissed = localStorage.getItem(key) !== null; } catch { /* Storage may be unavailable. */ }
  const dismiss = () => {
    notice.hidden = true;
    if (notice.contains(document.activeElement)) document.activeElement.blur();
    try { localStorage.setItem(key, 'dismissed'); } catch { /* Keep UI closed for this document. */ }
  };
  notice.querySelectorAll('[data-cookie-dismiss]').forEach(button => button.addEventListener('click', dismiss));
  notice.addEventListener('keydown', event => {
    if (event.key === 'Escape') dismiss();
  });
  window.addEventListener('storage', event => {
    if (event.key === key && event.newValue !== null) notice.hidden = true;
  });
  notice.hidden = dismissed;
})();
